import { request } from "./client";
export async function loginAdministrator(username: string, password: string) {
  return (await request<{ accessToken: string; expiresIn: number; administrator: { id: string; username: string } }>("/admin/auth/login", { method: "POST", body: JSON.stringify({ username, password }) })).data;
}
